import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    color: string;
    width: number;
}

export class ColorColumn extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        color: "",
        width: 180
    };

    constructor(props: IProperties)
    {
        super(props);
    }

    render()
    {
        return (
            <div
                className="n-table_cell"
                style={{
                    width: this.props.width
                }}>
                <div className="n-table_cell_color">
                    <div
                        className="n-table_cell_color_item"
                        style={{
                            backgroundColor: this.props.color
                        }}></div>
                </div>
            </div>
        );
    }
}